// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 152 ? "about" : chunkId) + "." + {"44":"6ecdda9f","152":"bca3bd49","576":"61f61996","780":"921fd767"}[chunkId] + ".css";
};